import { CardMedia, makeStyles, Typography, Box } from "@material-ui/core";
import PhoneIcon from "../assets/icons/phone.png";
const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    icon: {
      width: 11,
      height: 11,
      marginRight: 6,
    },
    phoneNumber: {
      fontSize: 16,
      lineHeight:0
    },
  };
});

const Phone = ({ number, disableIcon }) => {
  const classes = useStyles();
  if (!number) return null;
  number = String(number);
  number = number.replace("+66", "").replace(/\D/g, "");
  return (
    <Box className={classes.container}>
      {disableIcon ? null : (
        <CardMedia className={classes.icon} image={PhoneIcon}></CardMedia>
      )}

      <Typography className={classes.phoneNumber}>
        {`${number.slice(0, 3)}-${number.slice(3, 6)}-${number.slice(6, 11)}`}
      </Typography>
    </Box>
  );
};

export default Phone;
